<template>
    <div>
        <h1>Projects</h1>

        <!-- Projects Overview -->
        <div  v-if="!$route.params.id">
            <button @click="showCreate = !showCreate">{{showCreate ?'Hide':'Show'}} Create</button>
            <ProjectCreate class="SubForm" v-if="showCreate"></ProjectCreate>
            <ProjectList></ProjectList>
        </div>
        <ProjectDetail v-if="$route.params.id"></ProjectDetail>
    </div>
</template>

<script>
    // Import Helpers
    import {EnsureUserLoggedin} from '../Utilities.js'
    import ProjectList from '../components/ProjectList'
    import ProjectCreate from '../components/ProjectCreate'
    import ProjectDetail from '../components/ProjectDetail'

    // Module Code
    export default {
        beforeRouteEnter: EnsureUserLoggedin,
        components: {ProjectList, ProjectCreate, ProjectDetail},
        props: ['id'],
        data: function() {
            return {
                showCreate: false
            }
        }
    }
</script>